export const urlSearch = (url?: string) => url && new URL(url).search;
export const windowReplaceOriginUrl = () => window.location.replace(window.location.origin);
